import { UtmMatchType, UtmTag } from "./types";

export const UTM_TAG_LABEL: Record<UtmTag, string> = {
  [UtmTag.Source]: "Source",
  [UtmTag.Medium]: "Medium",
  [UtmTag.Campaign]: "Campaign",
  [UtmTag.Term]: "Term",
  [UtmTag.Content]: "Content"
};

export const UTM_MATCH_TYPE_LABEL: Record<UtmMatchType, string> = {
  [UtmMatchType.Is]: "is",
  [UtmMatchType.Contains]: "contains"
};

export const UTM_TAG_OPTIONS = Object.values(UtmTag).map((tag) => ({
  label: UTM_TAG_LABEL[tag],
  value: tag
}));

export const UTM_MATCH_TYPE_OPTIONS = Object.values(UtmMatchType).map(
  (matchType) => ({ label: UTM_MATCH_TYPE_LABEL[matchType], value: matchType })
);

// Mirror BoomCRM::LeadSource::UtmRule::Conditions (boompay-api).
export const MAX_UTM_CONDITIONS = 5;
export const UTM_VALUE_MAX_LENGTH = 255;

// Mirrors BoomCRM::LeadSource::PROTECTED_NAMES: written only by the invite
// flows, so a rule can't assign them.
export const PROTECTED_LEAD_SOURCE_NAMES = new Set([
  "BoomScreen invite",
  "Applicant invite"
]);

export const BOOM_LISTINGS_SOURCE_NAME = "Boom Listings";

export const CUSTOM_SOURCE_LOCK_TOOLTIP =
  "Assigning a custom lead source requires BoomCRM Pro";
